import { SlotRankHistoryMap } from "../../Model/Slot";
import { SlotRepository } from "../Repositories/SlotRepository";

/**
 * `/slots/{id}/rank_history/` 조회
 * - 서버가 배열/맵 등 어떤 형태로 내려줘도 UI에서 쓰는 `{[date]: number}` 맵으로 정규화합니다.
 * - null/undefined는 501(순위 밖)로 치환하여 UI에서 `>500 => 순위 밖` 규칙을 유지합니다.
 */
export class GetSlotRankHistoryUseCase {
  constructor(private repo: SlotRepository) {}

  private normalizeRankHistory(raw: unknown): SlotRankHistoryMap {
    // 이미 객체 맵 형태인 경우
    if (raw && typeof raw === "object" && !Array.isArray(raw)) {
      const obj = raw as Record<string, any>;
      const result: SlotRankHistoryMap = {};
      for (const [k, v] of Object.entries(obj)) {
        const parsed =
          v === null || v === undefined
            ? 501
            : typeof v === "number"
              ? v
              : Number.isNaN(Number(v))
                ? 501
                : Number(v);
        result[String(k)] = parsed;
      }
      return result;
    }

    // 배열 형태({ date, rank, ... })로 내려주는 경우
    if (Array.isArray(raw)) {
      const result: SlotRankHistoryMap = {};
      for (const item of raw as Array<any>) {
        const date = item?.date ?? item?.dt ?? item?.day ?? undefined;
        const rank = item?.rank ?? item?.value ?? item?.r ?? null;
        if (!date) continue;
        const parsed =
          rank === null || rank === undefined
            ? 501
            : typeof rank === "number"
              ? rank
              : Number.isNaN(Number(rank))
                ? 501
                : Number(rank);
        const key = String(date);
        const existing = result[key];
        // 같은 날짜에 숫자 순위와 Adlog placeholder가 같이 있으면 숫자를 유지
        if (existing !== undefined && existing !== 501 && parsed === 501) {
          continue;
        }
        result[key] = parsed;
      }
      return result;
    }

    return {};
  }

  async execute(slotId: number): Promise<SlotRankHistoryMap> {
    const raw = await this.repo.getSlotRankHistory(slotId);
    // 서버가 `{ rank_history: ... }` 형태로 감싸는 경우도 방어
    const payload =
      raw && typeof raw === "object" && (raw as any).rank_history !== undefined
        ? (raw as any).rank_history
        : raw;
    return this.normalizeRankHistory(payload);
  }
}


